export function BarChart({ values, labels = [] }) {
  const max = Math.max(...values) || 1;

  return (
    <div style={{ display: "flex", gap: 8, padding: "8px 4px" }}>
      {values.map((v, i) => {
        const pct = (v / max) * 100;
        return (
          <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1, gap: 6 }}>
            <div style={{ width: "100%", height: 150, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
              <div
                style={{
                  width: "70%",
                  background: "linear-gradient(180deg,var(--primary),var(--accent))",
                  borderRadius: "6px 6px 0 0",
                  height: `${pct}%`,
                  minHeight: 4,
                }}
              ></div>
            </div>
            <div style={{ fontSize: 11, color: "var(--text-3)", fontFamily: "var(--font-mono)" }}>{labels[i] ?? i}</div>
          </div>
        );
      })}
    </div>
  );
}

export default BarChart;
